<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Responsible Authorities"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <l-csv-import @on-import="onResponsibleAuthorities" />
    </l-container>

    <l-csv-export :exportPlugin="exportPlugin" :show="responsibleAuthorities.length > 0" filename="responsibleAuthorities" />

    <hot-table :data="responsibleAuthorities" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="Name" data="name" read-only="true"></hot-column>
      <hot-column title="Locator" data="locator" read-only="true"></hot-column>
      <hot-column title="Address" data="address" read-only="false"></hot-column>
      <hot-column title="Postcode" data="postcode" read-only="false"></hot-column>
      <hot-column title="Organisation" data="organisation" read-only="true"></hot-column>
      <hot-column title="Website" data="website" read-only="true"></hot-column>
      <hot-column title="Email" data="email" read-only="true"></hot-column>
      <hot-column title="Phone" data="phone" read-only="true"></hot-column>
      <hot-column title="Is responsible reporter?" data="is_responsible_reporter" read-only="true"></hot-column>
    </hot-table>
    <l-l-edit
      :showing="edit"
      @save="onSaveResponsibleAuthorities"
      @close="edit = false"
      :responsibleAuthorities="responsibleAuthorities"
      :selected="selected"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import ResponsibleAuthoritiesService from "./responsibleAuthorities.service";

import LLEdit from "./LLEdit";

import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";

import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";
import LCsvExport from '@/components/LCsvExport.vue';

export default {
  name: "responsibleAuthorities",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport,
    LCsvExport
  },
  data() {
    return {
      edit: false,
      loading: false,
      responsibleAuthorities: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      selected: {},
      exportPlugin: {}
    };
  },
  mounted() {
    //this.settings.afterSelectionEnd = this.selectRowOnly;
    this.exportPlugin = this.$refs.hot.hotInstance.getPlugin("exportFile");
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.responsibleAuthorities = await ResponsibleAuthoritiesService.responsibleAuthorities();
    },
    // async deleteResponsibleAuthorities(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await ResponsibleAuthorities.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Responsible Authorities deleted!");
    //   }
    // },
    async saveResponsibleAuthorities(ra) {
      const rowsAffected = await ResponsibleAuthoritiesService.update(ra);
      console.log("SAVED TO DB");

      const current = this.responsibleAuthorities.find(n => n.id == ra.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ra[prop];
          }
        }
      }
    },
    async importResponsibleAuthorities(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await ResponsibleAuthoritiesService.import(formData);
      this.responsibleAuthorities = await ResponsibleAuthoritiesService.responsibleAuthorities();
      Notify.success("Responsible authorities imported!");
    },
    async onResponsibleAuthorities(file) {
      await Notify.loadData(
        "Importing responisble authorities",
        this.importResponsibleAuthorities,
        file
      );
    },
    onEditResponsibleAuthorities(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.edit = true;
    },
    onNewResponsibleAuthorities(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = "";
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.edit = true;
    },
    onDeleteResponsibleAuthorities(t, o) {
      const endRow = o[0].end.row;
      const startRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              for (let index = startRow; index < endRow+1; index++) {
                var row = hot.getDataAtRow(index);
                const rowsAffected = await ResponsibleAuthoritiesService.delete(row[0]);
              }
              const activeEditor = hot.getActiveEditor();
              hot.alter('remove_row', startRow, endRow-startRow+1);
            }
          );
          Notify.success("Responsible Authorities deleted!");
        }
      }, "This will delete all data connected to this Responsible Authority(ies). <br/><br/>Do you want to continue?");
    },

    async onSaveResponsibleAuthorities(responsibleAuthorities) {
      await Notify.loadData(
        "Saving changes to Responsible Authorities " +
          responsibleAuthorities.id,
        this.saveResponsibleAuthorities,
        responsibleAuthorities
      );
      this.selected = {};
    }
  }
};
</script>



